import React from 'react'

function WorkingProcessThree() {
  return (
    <div>
        

        {/* Tmp Servisec Processs Area Two Start */}
        <div className="tpm-services-process-area   bg-working-1" style={{
            padding:"40px 0px"
        }}>
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="section-head">
                    <div className="section-sub-title center-title">
                    <img
                        src="assets/images/services/section-custom-menubar.png "
                        alt="Corporate_service"
                    />
                    <span className="subtitle">OUR   process</span>
                    </div>
                    <h2 className="title split-collab">Where Networking Meets Growth</h2>
                </div>
                </div>
            </div>
            <div className="row g-5">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <div className="single-services">
                    <div className="services-inner">
                    <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        
                        <img
                            src="assets/images/v2vimages/join-connect.jpg"
                            alt="Business consulting services"
                        />
                       
                        <div className="number-bg-round">
                        <span>01</span>
                        </div>
                    </div>
                    <div className="services-content services-content-style-1 text-center">
                        <h5 className="title"> Join & Connect  </h5>
                        <p className="description">
                        Sign up and become part of a thriving business community. Create your profile, explore industries, and start building valuable connections from day one.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <div className="single-services">
                    <div className="services-inner">
                    <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                         
                        <img
                             src="assets/images/v2vimages/collabrate.jpg"
                            alt="Business consulting services"
                        />
                        
                        <div className="number-bg-round">
                        <span>02</span>
                        </div>
                    </div>
                    <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Collaborate  </h5>
                        <p className="description">
                        Participate in discussions, attend exclusive events, and network with professionals. Exchange ideas, share insights, and discover new business opportunities.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <div className="single-services">
                    <div className="services-inner">
                    <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        
                        <img
                            src="assets/images/services/3.jpg"
                            alt="Business consulting services"
                        />
                        
                        <div className="number-bg-round">
                        <span>03</span>
                        </div>
                    </div>
                    <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">Grow & Succeed  </h5>
                        <p className="description">
                        Turn connections into lasting success. Access resources, form strategic partnerships, and unlock new opportunities for growth and innovation.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        {/* Tmp Servisec Processs Area Two End */}


    </div>
  )
}

export default WorkingProcessThree